import { ILogger } from '@cian/logger';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './LoadableErrorBoundary.css';

interface ILoadableErrorBoundaryProps {
  logger?: ILogger;
  onRetry(): void;
  children?: React.ReactNode;
  error?: boolean;
}

export const LoadableErrorBoundary: React.FC<ILoadableErrorBoundaryProps> = ({ children, error = false, onRetry }) => {
  const [hasError, setHasError] = React.useState(error);
  const handleRetryClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    onRetry();

    setHasError(false);
  };
  if (hasError) {
    return (
      <div className={styles['container']}>
        <p className={styles['text']}>
          Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.
        </p>
        <Button onClick={handleRetryClick}>Повторить</Button>
      </div>
    );
  }

  return <div>{children}</div>;
};
